import { Box, Text } from "grommet";
import { User } from "grommet-icons";
import React, { CSSProperties, FunctionComponent } from "react";
import StandardFonts from "../../../../../../../util/StandardFonts";
import './UserCard.css';

type UserCardComponentProps = {
  username: string;
  subText?: string;
  userNameFontStyle?: CSSProperties;
  subTextFontStyle?: CSSProperties;
  iconScale?: number;
  subTextComponent?: () => JSX.Element;
  onlineIndicator?: boolean;
  onlineIndicator2: boolean;
  isDetailScreen: boolean
};

const UserCardComponent: FunctionComponent<UserCardComponentProps> = ({
  username,
  subText,
  userNameFontStyle,
  subTextFontStyle,
  subTextComponent,
  onlineIndicator,
  onlineIndicator2,
  isDetailScreen
}: UserCardComponentProps): JSX.Element => {
  return (
    <Box style={styles.container}>
      {
      isDetailScreen != true 
      ?
        <Box margin={{ left: "10px" }}>
          <Text style={{ ...styles.name, ...userNameFontStyle }}>{username == "undefined undefined" ? "" : username}<span id="indicator" style={{width: 8,height: 8,borderRadius: 100,display: username == "" ? 'none' : 'inline-block',marginLeft: 6,backgroundColor: onlineIndicator ? "rgb(92, 210, 146)" : "#E35656"}} className="indicator"></span></Text>
          <Box>
            {subTextComponent ? (
              subTextComponent()
            ) : (
              <Text style={{ ...styles.sub, ...subTextFontStyle }}>
                {subText == undefined ? "" : "subText"}
              </Text>
            )}
          </Box>
        </Box>
      :
      <Box>
          {/* <Text style={{ ...styles.name, ...userNameFontStyle }}>{username}<span id="indicator2" style={{width: 8,height: 8,borderRadius: 100,display: 'inline-block',marginLeft: 5,backgroundColor: onlineIndicator2 ? "rgb(92, 210, 146)" : "#E35656"}} className="indicator"></span></Text> */}
          <Box>
            {subTextComponent ? (
              subTextComponent()
            ) : (
              <Text style={{ ...styles.sub, ...subTextFontStyle }}>
                {}
              </Text>
            )}
          </Box>
        </Box>
      
    }
    </Box>
  );
};

UserCardComponent.defaultProps = {
  userNameFontStyle: {},
  subTextFontStyle: {},
  iconScale: 1,
};

export default UserCardComponent;

const styles: { [key: string]: CSSProperties } = {
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    whiteSpace: 'nowrap'
  },

  name: {
    color: "#4B628A",
    fontFamily: "Inter",
    fontSize: 15,
    fontStyle: "normal",
    fontWeight: '600',
    lineHeight: 20
  },
  sub: {
    ...StandardFonts.capture1016Medium,
  },
};
